export { default } from './Hit';
